var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboardExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5334 3.0415H6.4667C4.40837 3.0415 2.7417 4.7165 2.7417 6.7665V14.6082C2.7417 16.6582 4.4167 18.3332 6.4667 18.3332H13.525C15.5834 18.3332 17.25 16.6582 17.25 14.6082V6.7665C17.2584 4.70817 15.5834 3.0415 13.5334 3.0415Z",
    fill: "#CCCFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9582 1.6665H8.04155C7.17489 1.6665 6.46655 2.3665 6.46655 3.23317V4.0165C6.46655 4.88317 7.16655 5.58317 8.03322 5.58317H11.9582C12.8249 5.58317 13.5249 4.88317 13.5249 4.0165V3.23317C13.5332 2.3665 12.8249 1.6665 11.9582 1.6665Z",
    fill: "#838B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05614 13.7248L10.9895 9.7915H9.9978C9.65614 9.7915 9.3728 9.50817 9.3728 9.1665C9.3728 8.82484 9.65614 8.5415 9.9978 8.5415H12.4978C12.8395 8.5415 13.1228 8.82484 13.1228 9.1665V11.6665C13.1228 12.0082 12.8395 12.2915 12.4978 12.2915C12.1561 12.2915 11.8728 12.0082 11.8728 11.6665V10.6748L7.93947 14.6082C7.81447 14.7332 7.65614 14.7915 7.4978 14.7915C7.33947 14.7915 7.18114 14.7332 7.05614 14.6082C6.81447 14.3665 6.81447 13.9665 7.05614 13.7248Z",
    fill: "#838B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardExport);
export default __webpack_public_path__ + "static/media/clipboard-export.d3e75f22b4b8f855373605c5b5a7f2c8.svg";
export { ForwardRef as ReactComponent };